The identifier for the `PositionOpening`.

This is included for HR-JSON compatibility;
GraphQL users should use the `positionOpening` nested object instead.
